import { Contact, PartyContact } from '../__graphql_generated__';

export enum ContactOutputType {
  DIRECTORY = 'DIRECTORY',
  NEW = 'NEW',
}

export type DrawerContact = {
  value?: Contact | PartyContact;
  contact?: Contact | PartyContact;
};
